import { base_url, makeRequestWithSilentLogin } from '../stores/GeneralStore';
import { createQueryFromFilter, firmPath } from "./EnzianDataApi";
export async function createFirm(signup) {
    const response = await fetch(base_url + "/" + firmPath + "/creation", {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(signup)
    });
    if (!response.ok) {
        throw await response.enzianJSON();
    }
    return await response.enzianJSON();
}
export async function getSignupData() {
    let response = await fetch(base_url + "/" + firmPath + "/signup-data", {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    });
    if (!response.ok) {
        throw await response.enzianJSON();
    }
    return await response.enzianJSON();
}
export async function sendEmailVerification(emailData) {
    let response = await fetch(base_url + "/email-verification", {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(emailData)
    });
    if (!response.ok) {
        throw await response.enzianJSON();
    }
    return await response.enzianJSON();
}
export async function getFirm(firmId) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + firmId);
}
const licenceInformationPath = "licence-information";
export async function getFirmLicenceInformation(firmId) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + firmId + "/" + licenceInformationPath);
}
const licencePath = "licences";
export async function getLicences(firmId) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + firmId + "/" + licencePath);
}
export async function getLicence(licenceId, firmId) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + firmId + "/" + licencePath + "/" + licenceId);
}
export async function patchLicence(licencePatch, firmId) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + firmId + "/" + licencePath, {
        method: "PATCH",
        body: JSON.stringify(licencePatch)
    });
}
export async function calculatePricesForLicences(firmId, request) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + firmId + "/calculate-prices", {
        method: 'POST',
        body: JSON.stringify(request)
    });
}
export async function getModulesWithDiscount(licenceId, firmId) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + firmId + "/" + licencePath + "/" + licenceId + "/prices");
}
let imageUploadLinkPath = "upload-image-attachment";
export async function getImageAttachmentUploadLink() {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + imageUploadLinkPath);
}
let imageFileLinkPath = "upload-file-attachment";
export async function getFileAttachmentUploadLink() {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + imageFileLinkPath);
}
let getAttachmentLinkPath = "resolve-attachment";
export async function getAttachmentLink(objectKey) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + getAttachmentLinkPath + "/" + objectKey);
}
let importUploadLink = "upload";
export async function getImportUploadLink() {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + importUploadLink);
}
const recommendPath = "recommend";
export async function recommendToFriend(request) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + recommendPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
let modulePath = "modules";
export async function assignModule(request) {
    return makeRequestWithSilentLogin(base_url + "/" + modulePath + "/assign-module", {
        method: 'POST',
        body: JSON.stringify(request)
    });
}
export async function buyModule(request) {
    return makeRequestWithSilentLogin(base_url + "/" + modulePath, {
        method: 'POST',
        body: JSON.stringify(request)
    });
}
export async function getRetailers() {
    return makeRequestWithSilentLogin(base_url + "/" + modulePath + "/retailers");
}
export async function renewLicences(request) {
    return makeRequestWithSilentLogin(base_url + "/" + modulePath + "/renew-modules", {
        method: 'POST',
        body: JSON.stringify(request)
    });
}
export async function toogleLicenceActivity(id) {
    return makeRequestWithSilentLogin(base_url + "/" + modulePath + "/" + id + "/toggle-module", {
        method: 'POST',
    });
}
export async function patchModule(patch) {
    return makeRequestWithSilentLogin(base_url + "/" + modulePath + "/" + patch.id, {
        method: 'PATCH',
        body: JSON.stringify(patch)
    });
}
export async function getModuleTypes() {
    //  Add the query param if its not undefined
    const response = await fetch(base_url + "/" + modulePath, {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    });
    if (!response.ok) {
        throw await response.enzianJSON();
    }
    return await response.enzianJSON();
}
let retailerCodePath = "retailer-code";
//Check if the retailer code is valid
export async function validateRetailerCode(retailerCode) {
    //  Add the query param if its not undefined
    const response = await fetch(base_url + "/" + retailerCodePath + "?retailerCode=" + retailerCode, {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    });
    if (!response.ok) {
        throw await response.enzianJSON();
    }
    return await response.enzianJSON();
}
let loginPath = "logins";
const loginCheckPath = "check";
export async function checkIfLoginNameExists(loginName) {
    let response = await fetch(base_url + "/" + loginPath + "/" + loginCheckPath + "?loginName=" + loginName, {
        method: 'HEAD',
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    });
    return response.ok;
}
export async function deleteLogin(loginId) {
    return makeRequestWithSilentLogin(base_url + "/" + loginPath + "/" + loginId, {
        method: 'DELETE',
    });
}
export async function createLogin(targetFirmId, request) {
    return makeRequestWithSilentLogin(base_url + "/" + loginPath + "/" + targetFirmId, {
        method: 'POST',
        body: JSON.stringify(request)
    });
}
export async function patchLogin(targetLoginId, request) {
    return makeRequestWithSilentLogin(base_url + "/" + loginPath + "/" + targetLoginId, {
        method: 'PATCH',
        body: JSON.stringify(request)
    });
}
const sbvLicencePath = "sbv-licence";
export async function patchSBVLicence(targetLoginId, request) {
    return makeRequestWithSilentLogin(base_url + "/" + loginPath + "/" + targetLoginId + "/" + sbvLicencePath, {
        method: 'PATCH',
        body: JSON.stringify(request)
    });
}
const twoFactorAuthPath = "two-factor-auth";
export async function getSetupTwoFactorAuth(targetLoginId) {
    return makeRequestWithSilentLogin(base_url + "/" + loginPath + "/" + targetLoginId + "/" + twoFactorAuthPath);
}
export async function deleteTwoFactorAuth(targetLoginId) {
    return makeRequestWithSilentLogin(base_url + "/" + loginPath + "/" + targetLoginId + "/" + twoFactorAuthPath, {
        method: "DELETE"
    });
}
const twoFactorAuthVerifyPath = "verify-and-active";
export async function postVerifyAndActivateTwoFactorAuth(targetLoginId, request) {
    return makeRequestWithSilentLogin(base_url + "/" + loginPath + "/" + targetLoginId + "/" + twoFactorAuthPath + "/" + twoFactorAuthVerifyPath, {
        method: 'POST',
        body: JSON.stringify(request)
    });
}
export async function getFirms(filter) {
    const query = createQueryFromFilter(filter);
    const url = base_url + "/" + firmPath;
    return makeRequestWithSilentLogin(url + query);
}
export async function patchFirm(firmId, patchFirm) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + firmId, {
        method: 'PATCH',
        body: JSON.stringify(patchFirm)
    });
}
export async function patchFirmSBVLicence(firmId, patchFirm) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + firmId + "/" + sbvLicencePath, {
        method: 'PATCH',
        body: JSON.stringify(patchFirm)
    });
}
export async function deleteFirm(firmId) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + firmId, {
        method: 'DELETE',
    });
}
let contactPersonPath = "contact";
export async function patchFirmContact(contactPersonId, patchContactPerson) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + contactPersonPath + "/" + contactPersonId, {
        method: 'PATCH',
        body: JSON.stringify(patchContactPerson)
    });
}
let supportTransactionPath = "support-transactions";
export async function getSupportTransactions(firmId) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + firmId + "/" + supportTransactionPath);
}
export async function deleteSupportTransaction(firmId, supportTransactionId) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + firmId + "/" + supportTransactionPath + "/" + supportTransactionId, {
        method: 'DELETE',
    });
}
export async function postSupportTransaction(firmId, createSupportTransaction) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + firmId + "/" + supportTransactionPath, {
        method: 'POST',
        body: JSON.stringify(createSupportTransaction)
    });
}
export async function postOrderSupportTransaction(firmId, orderSupportTransaction) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + firmId + "/" + supportTransactionPath + "/order", {
        method: 'POST',
        body: JSON.stringify(orderSupportTransaction)
    });
}
let productPath = "products";
export async function loadProducts(firmId) {
    return makeRequestWithSilentLogin(base_url + "/" + firmPath + "/" + firmId + "/" + productPath);
}
let ordersPath = "orders";
export async function loadOrder(orderId) {
    return makeRequestWithSilentLogin(base_url + "/" + ordersPath + "/" + orderId);
}
export async function loadOrders(targetFirmId, filter) {
    const query = createQueryFromFilter(filter);
    const url = base_url + "/" + firmPath + "/" + targetFirmId + "/" + ordersPath;
    return makeRequestWithSilentLogin(url + query);
}
export async function loadOrdersSysadmin(orderListFilter) {
    const query = createQueryFromFilter(orderListFilter);
    const url = base_url + "/" + ordersPath;
    return makeRequestWithSilentLogin(url + query);
}
let reminderPath = "reminder";
export async function sendReminderForOrder(orderId) {
    return makeRequestWithSilentLogin(base_url + "/" + ordersPath + "/" + orderId + "/" + reminderPath, {
        method: 'POST',
    });
}
let pdfPath = "pdf";
export async function getSignedLinkForOrderPDF(orderId) {
    return makeRequestWithSilentLogin(base_url + "/" + ordersPath + "/" + orderId + "/" + pdfPath);
}
let recreatePath = "recreate";
export async function postRecreateOrderPDF(orderId) {
    return makeRequestWithSilentLogin(base_url + "/" + ordersPath + "/" + orderId + "/" + pdfPath + "/" + recreatePath, {
        method: 'POST',
    });
}
export async function loadOrderStatuses() {
    return makeRequestWithSilentLogin(base_url + "/" + ordersPath + "/statuses");
}
export async function patchOrder(orderId, orderPatch) {
    return makeRequestWithSilentLogin(base_url + "/" + ordersPath + "/" + orderId, {
        method: 'PATCH',
        body: JSON.stringify(orderPatch)
    });
}
export async function getOrderHist(orderId) {
    return makeRequestWithSilentLogin(base_url + "/" + ordersPath + "/" + orderId + "/history");
}
let paymentsPath = "payments";
export async function addPaymentToOrder(orderId, frontendCreatePayment) {
    return makeRequestWithSilentLogin(base_url + "/" + ordersPath + "/" + orderId + "/" + paymentsPath, {
        method: 'POST',
        body: JSON.stringify(frontendCreatePayment)
    });
}
export async function deletePaymentFromOrder(orderId, paymentId) {
    return makeRequestWithSilentLogin(base_url + "/" + ordersPath + "/" + orderId + "/" + paymentsPath + "/" + paymentId, {
        method: 'DELETE',
    });
}
let orderEntryPath = "entries";
let orderEntryDiscountPath = "discounts";
export async function addDiscountToOrderEntry(orderId, orderEntryId, createOrderEntryDiscount) {
    return makeRequestWithSilentLogin(base_url + "/" + ordersPath + "/" + orderId + "/" + orderEntryPath + "/" + orderEntryId + "/" + orderEntryDiscountPath, {
        method: 'POST',
        body: JSON.stringify(createOrderEntryDiscount)
    });
}
export async function deleteOrderEntryDiscount(orderId, orderEntryId, orderEntryDiscountId) {
    return makeRequestWithSilentLogin(base_url + "/" + ordersPath + "/" + orderId + "/" + orderEntryPath + "/" + orderEntryId + "/" + orderEntryDiscountPath + "/" + orderEntryDiscountId, {
        method: 'DELETE',
    });
}
